import logger from '../log';
import racedPromise from '../common/utils/racedPromise';
import { PingData, probeUrlList } from '../locality/probeUrls';
import { addDuration } from '../common/utils/duration';
import { BasePromiseData, EMPTY_PROBE } from './interfaces';

const log = logger.getLogger(__filename);

export const getUncheckedUrls = (
  urlList?: string[],
  probe?: PingData
): string[] => {
  if (!urlList || urlList.length == 0) {
    return [];
  }
  const { probeUrls } = probe || {};
  if (!probeUrls || probeUrls.length == 0) {
    return urlList;
  }
  const seen = probeUrls.map(value => {
    return value.url;
  });
  // All we care about is a url in the new list that is not in the old.
  return urlList.filter(value => {
    return seen.indexOf(value) == -1;
  });
};

const getPrimingUrls = (obj: BasePromiseData): Promise<PingData> => {
  const { base, config, probe, vals } = obj;
  const urls = getUncheckedUrls(config.probeUrls, probe);
  log.info('getting probeUrls:', { probe, probeUrls: config.probeUrls });
  if (urls.length == 0) {
    log.debug('returning original probeurls', { probe });
    return Promise.resolve(probe || EMPTY_PROBE);
  }
  return racedPromise({
    ...base,
    callback: () => {
      addDuration({ vals, key: 'ping' });
    },
    response: EMPTY_PROBE,
    promise: probeUrlList(urls, probe)
  });
};

export default getPrimingUrls;
